// Lightweight i18n for slowcafe.kaily — supports en + zh-CN
import React, { createContext, useContext, useEffect, useMemo, useCallback } from "react";

export const TRANSLATIONS = {
    en: {
        "nav.services": "Services",
        "nav.work": "Work",
        "nav.process": "Process",
        "nav.pricing": "Pricing",
        "nav.subscribe": "Continuity",
        "nav.contact": "Contact",
        "nav.cta": "Start a project",
        "nav.lang": "中文",

        "hero.overline": "Kaily Gan · Malaysia-based F&B and Hospitality Filmmaker",
        "hero.title_1": "Cinematic Brand Films for ",
        "hero.title_2": "Food & Hospitality",
        "hero.title_3": "",
        "hero.body": "Kaily F&B Visual Studio — founded by Kaily Gan — is an independent visual studio crafting cinematic shop videos, editorial food photography and social-ready reels for cafés, restaurants and food brands across Malaysia — from kopitiams and matcha bars to Korean, Japanese, Indian, Chinese, Thai, Vietnamese, Western and Asian-fusion kitchens.",
        "hero.cta_primary": "Discuss a Project",
        "hero.cta_whatsapp": "WhatsApp Kaily",
        "hero.quick_price": "Fixed Packages",
        "hero.quick_ai": "Selected Work",
        "sticky.buy_now": "IG Content AI",
        "sticky.tagline": "30 days of posts · from RM 88",
        "hero.price_hint": "",
        "hero.location": "Brand films, campaigns & food content · KL & Selangor · International by custom quote",

        "services.overline": "What we do",
        "services.title_1": "Visuals that taste like ",
        "services.title_2": "your brand",
        "services.body": "From a single reel to a full brand campaign — we build visual content that makes small F&B teams look like the big ones, without losing the soul of what you built.",

        "pricing.overline": "Packages",
        "pricing.title_1": "Pick the ",
        "pricing.title_2": "shape ",
        "pricing.title_3": "of your shoot.",
        "pricing.body": "Transparent rates for the most common F&B briefs. Custom scopes welcome — just say hi.",
        "pricing.popular": "Most popular",
        "pricing.from": "from",
        "pricing.cta": "Book this package",
        "pricing.custom_title": "Need something custom?",
        "pricing.custom_body": "Multi-location shoot, brand campaign, monthly content retainer — let's design the right scope together.",
        "pricing.custom_cta": "Let's talk",

        "work.overline": "Selected work",
        "work.title_1": "Live from ",
        "work.see_full": "See full feed",
        "work.trusted": "Trusted by",

        "recent.overline": "Recent case studies",
        "recent.title_1": "Fresh from the ",
        "recent.title_2": "cutting room",
        "recent.see_all": "See all work",

        "process.overline": "How we work",
        "process.title_1": "An ",
        "process.title_2": "unhurried ",
        "process.title_3": "process, from first message to final cut.",

        "contact.overline": "Let's make something",
        "contact.title_1": "Tell us about ",
        "contact.title_2": "your spot",
        "contact.body": "Share a little about your brand, what you need, and when you need it. We reply within 24 hours — or just WhatsApp if that's easier.",
        "contact.form.name": "Your name *",
        "contact.form.business": "Business / cafe name",
        "contact.form.email": "Email *",
        "contact.form.phone": "Phone / WhatsApp",
        "contact.form.interested": "I'm interested in",
        "contact.form.budget": "Budget (RM)",
        "contact.form.timeline": "Timeline",
        "contact.form.message": "Tell us about your project *",
        "contact.form.submit": "Send inquiry",
        "contact.form.submitting": "Sending…",
        "contact.form.consent": "By submitting you agree to be contacted about your project.",
        "contact.form.name_ph": "Ada Wong",
        "contact.form.business_ph": "Ada's Coffee Co.",
        "contact.form.email_ph": "you@yourcafe.com",
        "contact.form.phone_ph": "+60 12 345 6789",
        "contact.form.budget_ph": "e.g. 500 – 2000",
        "contact.form.timeline_ph": "e.g. within 2 weeks",
        "contact.form.message_ph": "Your brand story, vibe you're going for, deliverables you need, location…",
        "contact.form.sent": "Sent · send another",

        "services.card.brand_film.title": "Brand Films",
        "services.card.brand_film.short": "60–180 second brand films that make the room feel the way it actually feels.",
        "services.card.brand_film.d1": "Director-led narrative",
        "services.card.brand_film.d2": "Licensed music",
        "services.card.brand_film.d3": "Platform-native cutdowns",
        "services.card.commercial.title": "Commercial Campaigns",
        "services.card.commercial.short": "Multi-asset campaigns around a product drop, menu launch or seasonal story.",
        "services.card.commercial.d1": "Brief → treatment → shoot",
        "services.card.commercial.d2": "Written rights & usage",
        "services.card.commercial.d3": "One revision round",
        "services.card.product.title": "Product Videos",
        "services.card.product.short": "Single-product hero films — flat-lay motion, hand rituals, close-up texture.",
        "services.card.product.d1": "15–45 s hero cuts",
        "services.card.product.d2": "4:5 + 9:16 masters",
        "services.card.product.d3": "Scoped per project",
        "services.card.reels.title": "Social Reels (Fixed Packages)",
        "services.card.reels.short": "Short-form reels for IG, TikTok and Xiaohongshu — fixed packages with locked deposits.",
        "services.card.reels.d1": "See packages for current pricing",
        "services.card.reels.d2": "Platform-native edits",
        "services.card.reels.d3": "Captions included",
        "services.card.food.title": "Food & Menu Photography",
        "services.card.food.short": "Editorial food stills for menu, delivery, in-store and press. Natural light first.",
        "services.card.food.d1": "Menu hero shots",
        "services.card.food.d2": "Flat-lay + 45°",
        "services.card.food.d3": "Scoped per project",

        "process.step.1.title": "Say hi",
        "process.step.1.body": "A short chat — we learn about your brand, your space, and the feeling you want to convey.",
        "process.step.2.title": "Plan the shoot",
        "process.step.2.body": "Shot list, mood board, wardrobe, dish styling, schedule — all mapped out before the camera comes out.",
        "process.step.3.title": "Shoot day",
        "process.step.3.body": "Half or full day on-site. Unhurried. Natural light first. We only keep what feels real.",
        "process.step.4.title": "Deliver",
        "process.step.4.body": "Colour-graded edits within 7–14 days, in every aspect ratio your platforms need.",

        "work.ig_overline": "Follow along on Instagram",
        "work.ig_subtitle": "fresh frames weekly.",
        "work.ig_see": "See @kaily_gan on Instagram",
        "work.ig_open": "Open @kaily_gan on Instagram",

        "services.list_hint": "See services page for current reel packages and campaign projects.",
        "services.see_rates": "See all rates",
        "services.start_brief": "Start a brief",

        "wwk.overline": "Working with Kaily",
        "wwk.title_1": "How I run a ",
        "wwk.title_2": "project",
        "wwk.intro": "This section is the fine print I'd actually read out loud. If any of these feel too direct, we're probably not the right fit — and that's useful information for both of us.",
        "wwk.point.1.title": "Director-led, not account-managed",
        "wwk.point.1.body": "You brief me, I direct the shoot. No junior planners, no vague deliverables — every scope item is written into the quotation before any booking.",
        "wwk.point.2.title": "Honest scope, written revisions",
        "wwk.point.2.body": "Deliverables, duration, locations, usage and one revision window are fixed in writing. Extra rounds are quoted openly. No 'unlimited revisions' promises.",
        "wwk.point.3.title": "No guaranteed sales claims",
        "wwk.point.3.body": "I don't promise follower counts or revenue uplift. I promise films and photos that look like your brand — the business result is yours to measure.",
        "wwk.point.4.title": "Mobile-first delivery",
        "wwk.point.4.body": "Every project ships with 16:9, 4:5, 1:1 and 9:16 cutdowns so your team can post straight from phone. Cloud gallery links don't expire.",

        "footer.tagline": "A F&B visual studio based in Selangor. It's about how it feels.",
        "footer.studio": "Studio",
        "footer.contact": "Contact",
        "footer.follow": "Follow",
        "footer.studio_addr": "Selangor, Malaysia\nAvailable across KL & beyond",
        "footer.made_slow": "Made slow, in Selangor",
        "footer.studio_link": "Studio",

        "intl.overline": "International Collaboration",
        "intl.title_1": "Malaysia-based director,",
        "intl.title_2": "cross-border briefs welcome",
        "intl.body": "I'm based in Selangor and I work with brands and agencies across Singapore, Japan, Taiwan and the wider region. Briefing happens in English (or Mandarin), production is quoted project by project, and invoices are issued in MYR with USD / SGD shown only as reference figures on proposals.",
        "intl.bullet_1": "Remote collaboration: you provide the raw material, I handle edit, grade and visual story.",
        "intl.bullet_2": "On-location work across SEA quoted with travel + rights written in.",
        "intl.bullet_3": "Licensed music, written usage rights, one revision window — same as local projects.",
        "intl.cta": "Start an International Brief",
        "intl.card_overline": "What I can confirm",
        "intl.card.based.k": "Based",
        "intl.card.based.v": "Selangor, Malaysia. On-location across KL, Klang Valley and SEA on-project.",
        "intl.card.lang.k": "Languages",
        "intl.card.lang.v": "English, Mandarin, Malay briefs.",
        "intl.card.invoice.k": "Invoicing",
        "intl.card.invoice.v": "MYR primary. USD / SGD shown as reference figures only.",
        "intl.card.rights.k": "Rights",
        "intl.card.rights.v": "written per project (territory + duration).",
        "intl.card.deposit.k": "Deposit",
        "intl.card.deposit.v": "50% to secure dates. Balance on delivery.",

        "sysver.updated": "Updated monthly",
        "sysver.system_prefix": "System",
        "sysver.whats_new": "What's new",
        "sysver.system_name": "Slowcafe System",
        "sysver.refreshed": "Refreshed",
        "sysver.whats_new_month": "What's new this month",
        "sysver.ig_trends": "This month's IG trends · sample",
        "sysver.ai.text": "Text",
        "sysver.ai.image": "Image",
        "sysver.ai.video": "Video",
        "sysver.ai.vision": "Vision",
        "sysver.summary_prefix": "",
        "sysver.summary_trends": " active trends · ",
        "sysver.summary_hooks": " hook formulas · ",
        "sysver.summary_styles": " visual styles. Every kit we deliver this month is built on this exact spec.",

        // ---- Site navigation ----
        "nav.work": "Work",
        "nav.malaysia": "Malaysia",
        "nav.international": "International",
        "nav.about": "About",
        "nav.contact": "Contact",
        "nav.cta_project": "Discuss a Project",
        "nav.service_regions": "Service Regions",
        "nav.malaysia_services": "Malaysia Services",
        "nav.international_projects": "International Projects",
        "nav.studio_subtitle": "F&B Visual Studio",

        // ---- Home hero overline (replaces "KAILY GAN / MALAYSIA & BEYOND") ----
        "hero.region_badge": "MALAYSIA & BEYOND",

        // ---- About page ----
        "about.overline": "About",
        "about.title_1": "Making films that look",
        "about.title_2": "the way the room feels",
        "about.intro": "I run a one-person studio from Malaysia, working with cafés, restaurants, hotels and lifestyle brands who want their visuals to feel honest.",
        "about.my_role.overline": "My role",
        "about.my_role.title": "What I actually do on your project",
        "about.my_role.body": "I take on the creative direction, filming and editing myself. No account managers between us — you talk to the person holding the camera. I lean towards natural light, unhurried pacing and food that looks the way it tastes.",
        "about.process.overline": "How we work together",
        "about.process.title": "From brief to final cut",
        "about.process.body": "Every project starts with a short conversation about the brand, the space and the feeling you want to carry. From there I write a brief treatment, scout and plan the shoot, direct the day with a small focused crew, and handle the edit, grade and delivery personally. One revision round is included; additional work is quoted openly before anything begins.",
        "about.cta_work": "View Work",
        "about.cta_contact": "Discuss a Project",
        "about.portrait_alt": "Portrait of Kaily Gan",

        // ---- International (full page i18n) ----
        "intl_page.hero.overline": "International",
        "intl_page.hero.title": "Based in Malaysia. Available for international brand projects.",
        "intl_page.hero.body": "I'm based in Selangor and travel for brand, hospitality and food projects across the region. Briefing happens in English or Mandarin, production is quoted project by project, and invoicing is in MYR with USD / SGD shown only as reference figures on proposals.",
        "intl_page.cta_brief": "Submit an International Brief",
        "intl_page.cta_work": "View Selected Work",
        "intl_page.cta_wa": "WhatsApp",
        "intl_page.showcase.overline": "Showcase",
        "intl_page.showcase.title": "Selected international work.",
        "intl_page.how.overline": "How we work",
        "intl_page.how.title": "An honest, project-based process.",
        "intl_page.how.footnote": "This page describes what has been confirmed in writing. Services not listed above (for example, cross-border product shipping, overseas-crew sourcing, in-country permits) are discussed on a per-brief basis and are not standing offerings.",
        "intl_page.how.filming.k": "Filming location",
        "intl_page.how.filming.v": "Based in Selangor, Malaysia. On-location work across Kuala Lumpur, Klang Valley and Southeast Asia is quoted per project — travel, permits and equipment logistics are agreed before the proposal is signed.",
        "intl_page.how.brief.k": "Pre-production brief",
        "intl_page.how.brief.v": "Share your brief in English or Mandarin: deliverables, references, deadline, intended usage. One short call to align on tone and scope before anything is quoted.",
        "intl_page.how.prod.k": "Production",
        "intl_page.how.prod.v": "Director + DOP on set with you, or remote collaboration where you provide the raw material and I handle edit, grade and visual story. Specific scope is confirmed per project.",
        "intl_page.how.deliv.k": "Delivery & revisions",
        "intl_page.how.deliv.v": "Master cut plus social cutdowns delivered via WeTransfer / Frame.io. One round of revisions is included. Licensed music, written usage rights (territory + duration) agreed in the proposal.",
        "intl_page.how.quote.k": "Quote & currency",
        "intl_page.how.quote.v": "International projects are quoted bespoke — local Malaysia packages are not simply converted to foreign currencies. Invoicing is in MYR; USD or SGD, if listed, appear only as reference figures on the proposal.",
        "intl_page.how.timeline.k": "Timeline",
        "intl_page.how.timeline.v": "Rough cut within 7–10 business days of shoot. Full production window depends on scope; typical post is 2–3 weeks.",
        "intl_page.brief.overline": "Start a project",
        "intl_page.brief.title": "Share your brief.",
        "intl_page.brief.body": "About 60 seconds. Kaily reads every brief personally and replies within 1 business day (Asia/Kuala_Lumpur).",
        "intl_page.form.name": "Your name",
        "intl_page.form.email": "Email",
        "intl_page.form.brand": "Brand / Company",
        "intl_page.form.country": "Filming country / city",
        "intl_page.form.country_ph": "e.g. Singapore · Orchard",
        "intl_page.form.project_type": "Project type",
        "intl_page.form.timeline": "Target production month",
        "intl_page.form.timeline_ph": "e.g. April 2026",
        "intl_page.form.budget": "Budget (optional)",
        "intl_page.form.budget_ph": "e.g. MYR 15k, or a range — reference figures only",
        "intl_page.form.refs": "Reference links (optional)",
        "intl_page.form.brief": "Brief",
        "intl_page.form.brief_ph": "Deliverables (format, count), creative references, deadline, intended usage, any constraints we should know.",
        "intl_page.form.submit": "Send Brief to Kaily",
        "intl_page.form.submitting": "Sending…",
        "intl_page.form.footnote": "Invoicing in MYR. USD or SGD, if listed in a proposal, are reference figures only — not accepted settlement currencies for this release.",
        "intl_page.form.err_missing": "Please fill in name, email, and brief",
        "intl_page.form.ok_toast": "Thanks — Kaily will reply within 1 business day (Asia/Kuala_Lumpur).",
        "intl_page.form.err_toast": "Submission failed",
        "intl_page.form.done.title": "Thanks — brief received",
        "intl_page.form.done.body_1": "Kaily will reply from",
        "intl_page.form.done.body_2": "within 1 business day. If it's urgent, you can also WhatsApp +60 18-362 8663.",
        "intl_page.project_types.brand": "Brand Film / Hero Film",
        "intl_page.project_types.product": "F&B Product Campaign",
        "intl_page.project_types.hospitality": "Hospitality / Hotel Campaign",
        "intl_page.project_types.travel": "Travel / Destination Content",
        "intl_page.project_types.reels": "Social Reels Series",
        "intl_page.project_types.photo": "Still Photography · Food / Menu",
        "intl_page.project_types.other": "Other — tell us",
    },
    cn: {
        "nav.services": "服务",
        "nav.work": "作品",
        "nav.process": "流程",
        "nav.pricing": "价格",
        "nav.subscribe": "持续服务",
        "nav.contact": "联系",
        "nav.cta": "开始合作",
        "nav.lang": "EN",

        "hero.overline": "Kaily Gan · 马来西亚 F&B 与酒店业电影导演",
        "hero.title_1": "为餐饮与酒店打造的",
        "hero.title_2": "电影感品牌影片",
        "hero.title_3": "",
        "hero.body": "Kaily F&B Visual Studio 是 Kaily Gan 创立的独立视觉工作室，为马来西亚的咖啡馆、餐厅与美食品牌打造电影感店面宣传片、美食大片摄影和社交平台短视频 —— 涵盖 kopitiam、抹茶吧、韩餐、日料、印度餐、中餐、泰餐、越南菜、西餐与亚洲融合料理。",
        "hero.cta_primary": "咨询项目",
        "hero.cta_whatsapp": "WhatsApp 联系 Kaily",
        "hero.quick_price": "固定套餐",
        "hero.quick_ai": "精选作品",
        "sticky.buy_now": "IG 内容 AI",
        "sticky.tagline": "30 天发布内容 · RM 88 起",
        "hero.price_hint": "",
        "hero.location": "品牌影片、宣传与餐饮内容 · 吉隆坡与雪兰莪 · 国际项目按明确币种定制报价",

        "services.overline": "我们做的事",
        "services.title_1": "贴合 ",
        "services.title_2": "你品牌味道",
        "services.body": "从一条 Reel 到完整品牌战役 — 我们做的内容,让小餐饮品牌看起来跟连锁一样精致,但不丢掉你最初做这家店的初心。",

        "pricing.overline": "套餐价格",
        "pricing.title_1": "选一个 ",
        "pricing.title_2": "适合你 ",
        "pricing.title_3": "的拍摄方案。",
        "pricing.body": "餐饮行业最常见拍摄需求的透明价格。需要更复杂的项目?直接来聊。",
        "pricing.popular": "最受欢迎",
        "pricing.from": "起价",
        "pricing.cta": "选这个套餐",
        "pricing.custom_title": "需要专属方案?",
        "pricing.custom_body": "多地点拍摄、品牌战役、长期月度内容包 — 我们一起设计最合适的规模。",
        "pricing.custom_cta": "来聊聊",

        "work.overline": "精选作品",
        "work.title_1": "实时同步自 ",
        "work.see_full": "看完整 IG",
        "work.trusted": "服务过",

        "recent.overline": "最新案例",
        "recent.title_1": "刚出剪辑室的 ",
        "recent.title_2": "热乎作品",
        "recent.see_all": "查看全部作品",

        "process.overline": "合作流程",
        "process.title_1": "从第一条消息,到最后一帧 — ",
        "process.title_2": "不慌不忙",
        "process.title_3": "的完整流程。",

        "contact.overline": "聊聊你的店",
        "contact.title_1": "告诉我们 ",
        "contact.title_2": "你的故事",
        "contact.body": "说说你的品牌、你需要什么、什么时候要 — 我们 24 小时内回复。或者直接 WhatsApp 也行。",
        "contact.form.name": "你的名字 *",
        "contact.form.business": "店名 / 品牌名",
        "contact.form.email": "邮箱 *",
        "contact.form.phone": "电话 / WhatsApp",
        "contact.form.interested": "我想了解",
        "contact.form.budget": "预算(RM)",
        "contact.form.timeline": "时间安排",
        "contact.form.message": "聊聊你的项目 *",
        "contact.form.submit": "发送询价",
        "contact.form.submitting": "发送中…",
        "contact.form.consent": "提交即表示同意我们就此项目联系你。",
        "contact.form.name_ph": "张同学",
        "contact.form.business_ph": "你的品牌 / 店名",
        "contact.form.email_ph": "you@yourcafe.com",
        "contact.form.phone_ph": "+60 12 345 6789",
        "contact.form.budget_ph": "例如 500 – 2000",
        "contact.form.timeline_ph": "例如 两周内",
        "contact.form.message_ph": "品牌故事、想要的氛围、需要的交付物、地点……",
        "contact.form.sent": "已发送 · 再发一条",

        "services.card.brand_film.title": "品牌影片",
        "services.card.brand_film.short": "60–180 秒品牌影片 — 把店里真实的感觉拍出来。",
        "services.card.brand_film.d1": "导演叙事",
        "services.card.brand_film.d2": "授权音乐",
        "services.card.brand_film.d3": "平台原生剪辑",
        "services.card.commercial.title": "商业广告 Campaign",
        "services.card.commercial.short": "围绕新品上架、菜单发布、季度主题的多素材广告 Campaign。",
        "services.card.commercial.d1": "Brief → 创意 → 拍摄",
        "services.card.commercial.d2": "版权与使用书面约定",
        "services.card.commercial.d3": "一轮修改",
        "services.card.product.title": "产品影片",
        "services.card.product.short": "单品 Hero 影片 — 平铺、手部动作、特写质感。",
        "services.card.product.d1": "15–45 秒 Hero",
        "services.card.product.d2": "4:5 + 9:16 母版",
        "services.card.product.d3": "按项目报价",
        "services.card.reels.title": "社交短片套餐",
        "services.card.reels.short": "针对 IG / TikTok / 小红书的短片 — 固定套餐、定金锁档。",
        "services.card.reels.d1": "套餐价见服务页",
        "services.card.reels.d2": "平台原生剪辑",
        "services.card.reels.d3": "含字幕",
        "services.card.food.title": "美食与菜单摄影",
        "services.card.food.short": "适合菜单、外送平台、门店与媒体的编辑式美食静态 — 优先自然光。",
        "services.card.food.d1": "菜单 Hero 图",
        "services.card.food.d2": "平铺 + 45° 俯拍",
        "services.card.food.d3": "按项目报价",

        "process.step.1.title": "打个招呼",
        "process.step.1.body": "简单聊聊 — 了解你的品牌、店里的空间,以及你想传达的感觉。",
        "process.step.2.title": "规划拍摄",
        "process.step.2.body": "分镜、Mood board、服装、菜品造型、拍摄排程 — 在相机对准之前全部定好。",
        "process.step.3.title": "拍摄当天",
        "process.step.3.body": "半天或整天到场。不慌不忙,自然光优先。只留下真实的画面。",
        "process.step.4.title": "交付",
        "process.step.4.body": "7–14 天内完成调色与剪辑,交付你所有平台需要的画幅。",

        "work.ig_overline": "在 Instagram 持续更新",
        "work.ig_subtitle": "每周新鲜画面。",
        "work.ig_see": "在 Instagram 看 @kaily_gan",
        "work.ig_open": "打开 Instagram @kaily_gan",

        "services.list_hint": "更多社交短片套餐与 Campaign 项目请见服务页。",
        "services.see_rates": "查看价格",
        "services.start_brief": "开启项目",

        "wwk.overline": "和 Kaily 合作",
        "wwk.title_1": "我是怎么推进一个 ",
        "wwk.title_2": "项目的",
        "wwk.intro": "这一段是我真的会和客户当面讲的实话。如果其中任何一点让你觉得太直接 — 那我们可能不是最合适的组合,这对双方都是重要信息。",
        "wwk.point.1.title": "导演主导,不是客户经理模式",
        "wwk.point.1.body": "你来 brief,我亲自导演拍摄。没有初级 planner、没有模糊交付清单 — 每一项范围都写进报价单后才开始订档。",
        "wwk.point.2.title": "诚实的范围、书面的修改约定",
        "wwk.point.2.body": "交付物、拍摄时长、地点、使用授权与一轮修改窗口都写在合约里。额外轮次公开报价。不承诺 '无限修改'。",
        "wwk.point.3.title": "不保证销售数字",
        "wwk.point.3.body": "我不承诺你涨粉或业绩增长。我承诺的是和品牌气质匹配的影片与照片 — 商业结果由你去衡量。",
        "wwk.point.4.title": "优先手机端交付",
        "wwk.point.4.body": "每个项目都包含 16:9 / 4:5 / 1:1 / 9:16 剪辑,方便你团队从手机直接发布。云端相册链接永不过期。",

        "footer.tagline": "一家位于 Selangor 的餐饮视觉工作室。重要的是感觉。",
        "footer.studio": "工作室",
        "footer.contact": "联系方式",
        "footer.follow": "关注",
        "footer.studio_addr": "Selangor, Malaysia\n服务覆盖 KL 与全马",
        "footer.made_slow": "慢慢做,在 Selangor",
        "footer.studio_link": "后台",

        "intl.overline": "国际合作",
        "intl.title_1": "马来西亚本地导演,",
        "intl.title_2": "欢迎跨境项目",
        "intl.body": "我驻 Selangor,长期和新加坡、日本、台湾等地的品牌与广告公司合作。沟通可用英文或中文,制作按项目报价,发票以 MYR 为主,USD / SGD 仅作提案参考货币。",
        "intl.bullet_1": "远程协作:你提供素材,我负责剪辑、调色与视觉叙事。",
        "intl.bullet_2": "跨东南亚实地拍摄按项目报价,含差旅与使用授权。",
        "intl.bullet_3": "授权音乐、书面使用权、一轮修改 — 与本地项目一致。",
        "intl.cta": "开启跨境项目",
        "intl.card_overline": "我能确认的事",
        "intl.card.based.k": "坐标",
        "intl.card.based.v": "Selangor, 马来西亚。按项目可到 KL、Klang Valley 及东南亚实地拍摄。",
        "intl.card.lang.k": "语言",
        "intl.card.lang.v": "英文、中文、马来文 brief 皆可。",
        "intl.card.invoice.k": "开票",
        "intl.card.invoice.v": "以 MYR 为主,USD / SGD 仅作提案参考。",
        "intl.card.rights.k": "使用授权",
        "intl.card.rights.v": "按项目书面约定(地区范围 + 时效)。",
        "intl.card.deposit.k": "定金",
        "intl.card.deposit.v": "50% 锁档,交付时付清尾款。",

        "sysver.updated": "每月更新",
        "sysver.system_prefix": "系统版本",
        "sysver.whats_new": "本月更新",
        "sysver.system_name": "Slowcafe 系统",
        "sysver.refreshed": "更新于",
        "sysver.whats_new_month": "本月更新内容",
        "sysver.ig_trends": "本月 IG 趋势 · 示例",
        "sysver.ai.text": "文本模型",
        "sysver.ai.image": "图像模型",
        "sysver.ai.video": "视频模型",
        "sysver.ai.vision": "视觉模型",
        "sysver.summary_prefix": "本月共 ",
        "sysver.summary_trends": " 个趋势 · ",
        "sysver.summary_hooks": " 个 Hook 公式 · ",
        "sysver.summary_styles": " 种视觉风格。本月所有 Kit 均基于此配置生成。",

        // ---- Site navigation ----
        "nav.malaysia": "马来西亚服务",
        "nav.international": "国际合作",
        "nav.about": "关于",
        "nav.cta_project": "开启项目",
        "nav.service_regions": "服务地区",
        "nav.malaysia_services": "马来西亚服务",
        "nav.international_projects": "国际合作项目",
        "nav.studio_subtitle": "餐饮视觉工作室",

        // ---- Home hero overline (replaces 甘可爱 / 马来西亚 & 海外) ----
        "hero.region_badge": "马来西亚 & 海外",

        // ---- About page ----
        "about.overline": "关于",
        "about.title_1": "拍出来的画面,",
        "about.title_2": "等于空间真实的感觉",
        "about.intro": "我在马来西亚经营一间一人工作室,服务咖啡馆、餐厅、酒店与生活方式品牌,把真实的氛围转化为影像。",
        "about.my_role.overline": "我的角色",
        "about.my_role.title": "我在项目里实际做什么",
        "about.my_role.body": "创意方向、拍摄和剪辑都由我亲自负责。没有中间的客户经理 — 你直接和拿相机的人沟通。我偏好自然光、从容的节奏,以及食物本身应有的样子。",
        "about.process.overline": "我们如何合作",
        "about.process.title": "从一次沟通,到最终成片",
        "about.process.body": "每个项目从一次简短的沟通开始 — 聊你的品牌、空间,以及你希望传达的感觉。接下来我会写一份简要的创意提案、勘景并规划拍摄,拍摄当天由我亲自导演并带一支精简团队。剪辑、调色与交付都由我亲自完成。合约包含一轮修改,额外工作在开始之前都会公开报价。",
        "about.cta_work": "查看作品",
        "about.cta_contact": "讨论项目",
        "about.portrait_alt": "Kaily Gan 肖像",

        // ---- International (full page i18n) ----
        "intl_page.hero.overline": "国际合作",
        "intl_page.hero.title": "立足马来西亚,承接跨国品牌项目。",
        "intl_page.hero.body": "我驻雪兰莪,长期与新加坡、日本、台湾等区域的品牌、酒店与广告公司合作。沟通可用英文或中文,制作按项目报价。发票以 MYR 为主,USD / SGD 仅作提案参考货币。",
        "intl_page.cta_brief": "提交国际项目需求",
        "intl_page.cta_work": "查看精选作品",
        "intl_page.cta_wa": "WhatsApp 联系",
        "intl_page.showcase.overline": "精选作品",
        "intl_page.showcase.title": "精选国际项目。",
        "intl_page.how.overline": "合作流程",
        "intl_page.how.title": "按项目诚实报价的流程。",
        "intl_page.how.footnote": "本页描述的都是已书面确认的内容。未列出的服务(例如跨境商品运输、海外团队搭建、当地拍摄许可)按项目逐案协商,不是我们固定提供的产品。",
        "intl_page.how.filming.k": "拍摄地点",
        "intl_page.how.filming.v": "常驻雪兰莪。吉隆坡、巴生谷与东南亚实地拍摄按项目报价 — 差旅、许可、设备物流在报价书签订前先约定清楚。",
        "intl_page.how.brief.k": "前期沟通",
        "intl_page.how.brief.v": "英文或中文都可以 brief:交付物、参考案例、截止日期、使用场景。先约一次简短通话对齐风格与范围,再开始报价。",
        "intl_page.how.prod.k": "制作",
        "intl_page.how.prod.v": "导演 + 摄影师现场陪你拍,或者由你提供原始素材、我负责剪辑、调色与视觉叙事。具体范围按项目确认。",
        "intl_page.how.deliv.k": "交付与修改",
        "intl_page.how.deliv.v": "主片与社媒剪辑通过 WeTransfer / Frame.io 交付。包含一轮修改。授权音乐、书面使用权(地区范围 + 时效)在报价书中约定。",
        "intl_page.how.quote.k": "报价与结算币种",
        "intl_page.how.quote.v": "国际项目按需定制报价 — 不会把本地马来套餐简单换算成外币。发票以 MYR 为主;报价书上出现的 USD / SGD 仅作参考。",
        "intl_page.how.timeline.k": "周期",
        "intl_page.how.timeline.v": "拍摄后 7–10 个工作日内交粗剪。整体制作周期视范围而定,通常后期 2–3 周。",
        "intl_page.brief.overline": "开启项目",
        "intl_page.brief.title": "分享你的需求。",
        "intl_page.brief.body": "大约 60 秒。Kaily 会亲自阅读每份 brief,并在 1 个工作日内回复(马来西亚时间)。",
        "intl_page.form.name": "你的名字",
        "intl_page.form.email": "邮箱",
        "intl_page.form.brand": "品牌 / 公司",
        "intl_page.form.country": "拍摄国家 / 城市",
        "intl_page.form.country_ph": "例:新加坡 · Orchard",
        "intl_page.form.project_type": "项目类型",
        "intl_page.form.timeline": "预计拍摄月份",
        "intl_page.form.timeline_ph": "例:2026 年 4 月",
        "intl_page.form.budget": "预算(选填)",
        "intl_page.form.budget_ph": "例:MYR 15k 或预算范围 — 仅作参考",
        "intl_page.form.refs": "参考链接(选填)",
        "intl_page.form.brief": "项目简介",
        "intl_page.form.brief_ph": "交付物(类型、数量)、创意参考、截止日期、使用场景,以及任何我们需要先知道的信息。",
        "intl_page.form.submit": "发送 Brief 给 Kaily",
        "intl_page.form.submitting": "发送中…",
        "intl_page.form.footnote": "以 MYR 开票。报价书上若标示 USD 或 SGD,仅为参考数字 — 本阶段不作为结算币种。",
        "intl_page.form.err_missing": "请填写姓名、邮箱与项目简介",
        "intl_page.form.ok_toast": "已收到 — Kaily 会在 1 个工作日内回复(马来西亚时间)。",
        "intl_page.form.err_toast": "提交失败",
        "intl_page.form.done.title": "已收到 — 感谢你的 brief",
        "intl_page.form.done.body_1": "Kaily 会从",
        "intl_page.form.done.body_2": "在 1 个工作日内回复。急件也可直接 WhatsApp +60 18-362 8663。",
        "intl_page.project_types.brand": "品牌影片 / Hero Film",
        "intl_page.project_types.product": "餐饮产品 Campaign",
        "intl_page.project_types.hospitality": "酒店 / 住宿 Campaign",
        "intl_page.project_types.travel": "旅行 / 目的地内容",
        "intl_page.project_types.reels": "系列短视频",
        "intl_page.project_types.photo": "静态摄影 · 美食 / 菜单",
        "intl_page.project_types.other": "其他 — 说明一下",
    },
};

const LangContext = createContext({ lang: "en", t: (k) => k });

export function LanguageProvider({ lang, children }) {
    useEffect(() => {
        const isCN = lang === "cn";
        document.documentElement.lang = isCN ? "zh-CN" : "en";
        // Per-route SEO (lib/seo-data.js via SeoManager) owns title/description
        // for registered routes; this legacy fallback only covers the rest.
        const { ROUTES } = require("@/lib/seo-data");
        const path = window.location.pathname.replace(/\/+$/, "") || "/";
        if (ROUTES[path]) return;
        if (isCN) {
            document.title = "Kaily F&B Visual Studio — 雪兰莪餐饮视觉工作室 · 美食摄影 · 店面视频";
            const desc = document.querySelector('meta[name="description"]');
            if (desc) desc.setAttribute("content", "Kaily F&B Visual Studio 是 Selangor 的独立餐饮视觉工作室 — 为咖啡馆、餐厅与美食品牌打造电影感品牌影片、商业宣传、美食摄影与社媒短视频。国际项目按明确币种定制报价。");
        } else {
            document.title = "Kaily F&B Visual Studio — Selangor · KL · Malaysia";
            const desc = document.querySelector('meta[name="description"]');
            if (desc) desc.setAttribute("content", "Kaily F&B Visual Studio (slowcafe.my) is an independent F&B visual studio in Selangor, serving KL, Klang Valley and Malaysia — cinematic brand films, commercial campaigns, editorial food photography and social-ready reels for cafes, restaurants and food brands. International work by custom quote with explicit currency.");
        }
    }, [lang]);

    const t = useCallback(
        (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key,
        [lang]
    );
    const value = useMemo(() => ({ lang, t }), [lang, t]);
    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useT() {
    return useContext(LangContext);
}
